import { Icon, IconBase64 } from '@synergy/icons';
import { Col, Divider, Row } from "antd";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import Theme from "../../styles/Theme/Theme";
import { REACT_APP_COMMAND_INCIDENT_URL, REACT_APP_COMMAND_LOG_ITEM_URL } from '../../utils/config/configs';
import { formatTimestamp } from '../../utils/hooks/dateSerialization';
import { getColorBySeverity } from '../../utils/hooks/getColorByPriority';
import { groupBy } from "../../utils/hooks/gourpBy";
import { isEmpty } from "../../utils/hooks/isEmpty";
import { isLogItem } from '../../utils/hooks/logItems';
import Button from "../Global/Atomics/Button";
import Container from "../Global/Atomics/Container";

const ServiceGroup = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    > span {
        display: flex;
        align-items: center;
        color: ${Theme.color['blue-4']};
        cursor: pointer;

        &:hover {
            transition: all 0.3s ease-in-out;
            transform: scale(1.05);
        }
    }
`;

const ServiceNameText = styled.div`
    /* margin-bottom: 10px; */
    font-weight: bold;
    align-content: center;
`;

const ViewDetailsSpan = styled.span`
    display: flex;
    align-items: center;
    gap: 5;
    color: #0076A8;
    margin: 0;
    cursor: pointer;

    &:hover {
        transition: all 0.3s ease-in-out;
        transform: scale(1.05);
    }
`;

export const RegisterDetailClusterView = ({ selectedCluster, setSelectedPOI, selectedLayer }) => {
    if (!selectedCluster || isEmpty(selectedCluster)) {
        return null;
    };

    const { t, i18n } = useTranslation();
    const [createIncidentModal, setCreateIncidentModal] = useState(false);
    const [coordinatesToCreateIncident, setCoordinatesToCreateIncident] = useState(null);

    const createIncident = (subKey) => {
        setCreateIncidentModal(true);
        const lat = subKey.split('/')[0];
        const lng = subKey.split('/')[1];
        setCoordinatesToCreateIncident({ lat, lng });
    };

    const urlToCommand = (item) => isLogItem(item) ? REACT_APP_COMMAND_LOG_ITEM_URL : REACT_APP_COMMAND_INCIDENT_URL;

    return (
        <>
            {Object.entries(selectedCluster).map(([key, value], index) => {
                const groupbyServiceName = groupBy(value, 'serviceName');

                if (!groupbyServiceName || isEmpty(groupbyServiceName)) {
                    return null;
                }

                return (
                    <div key={index}>
                        {Object.entries(groupbyServiceName).map(([subKey, subValue], subIndex) => (
                            <div key={subIndex}>
                                {selectedLayer === 'Incidents' ?
                                    <ServiceGroup>
                                        <ServiceNameText>{subKey.toUpperCase()}</ServiceNameText>
                                        {/* <span onClick={() => createIncident(subKey)}>{t('button.create_incident')} <Icon icon='Plus' color={Theme.color['blue-4']} iconsize="xs" /></span> */}
                                    </ServiceGroup>
                                    : null}
                                {subValue.map((item, index) => (
                                    <Container fontSize='1rem' justifyItem='flex-start' alignItem='flex-start'
                                        titlePadding='0px' key={index} width='100%' wrapperMinHeight='auto' cardMarginBottom='20px'>
                                        {selectedLayer === 'Incidents' ?
                                            <Row gutter={[16, 16]} style={{ width: '100%' }}>
                                                <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                                                    {/* <img src={IconBase64(item)}
                                                        width='35px' /> */}
                                                    {/* <Icon iconsize={'xs'} icon={item.class} color={'#0076A8'} $backgroundColor='blue-1' /> */}
                                                    <Icon
                                                        icon={isLogItem(item) ? 'Information' : item.class}
                                                        color="white"
                                                        bgColor={isLogItem(item) ? Theme.color["log-item"] : getColorBySeverity(item.severity)}
                                                        strokeWidth='1'
                                                        iconsize='md'
                                                        bgPadding='4px'
                                                    />
                                                </Col>
                                                <Col span={10}>
                                                    <PropertiesBox title={
                                                        isLogItem(item) ? `${t("input.log_item_category")}` : t('Issue number')
                                                    }
                                                        value={isLogItem(item) ? item.category : item.name}
                                                    />
                                                </Col>
                                                <Col span={10} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Button size='xxs' $backgroundColor={Theme.color['blue-4']}
                                                        onClick={() => window.open(`${urlToCommand(item)}${item.id}`, '_blank')}
                                                    >
                                                        {
                                                            isLogItem(item) ?
                                                                t('Manage Log Item') :
                                                                t('Manage Issue')
                                                        }
                                                    </Button>
                                                </Col>
                                                <Divider style={{ margin: '16px 0', borderTop: '1px solid #ccc' }} />

                                                <Col span={24}>
                                                    <Row gutter={[16, 16]}>
                                                        <Col span={9}>
                                                            <PropertiesBox title={t('Last update')} value={item.lastUpdate ? formatTimestamp(item.lastUpdate, i18n.language) : 'N/A'} />
                                                        </Col>
                                                        <Col span={9}>
                                                            <PropertiesBox title={t('issueOwnerGroup')} value={item.issueOwnerGroup} />
                                                        </Col>
                                                        <Col span={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                            <ViewDetailsSpan onClick={() => setSelectedPOI(item)}>{t('View Details')}<Icon iconsize={'xs'} icon="ArrowRight" color={'#0076A8'} /></ViewDetailsSpan>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            :
                                            <Row gutter={[16, 16]} style={{ width: '100%' }}>
                                                <Col span={4} style={{ display: 'flex', alignItems: 'center' }}>
                                                    <img src={IconBase64(item)}
                                                        width='35px' />
                                                </Col>
                                                <Col span={8}>
                                                    <PropertiesBox title={t('Service Name')} value={item.name} />
                                                </Col>
                                                <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <ViewDetailsSpan onClick={() => setSelectedPOI(item)}>{t('View Details')}<Icon iconsize={'xs'} icon="ArrowRight" color={'#0076A8'} /></ViewDetailsSpan>
                                                </Col>
                                            </Row>
                                        }
                                    </Container>
                                ))}

                                {selectedLayer === 'Incidents' ? <Divider style={{ border: '1px solid gray' }} /> : null}
                            </div>
                        ))}
                    </div>
                );
            })}

            {/* <MapCreateIncidentModal isCreateIncidentModalOpen={createIncidentModal} setCreateIncidentModal={setCreateIncidentModal} mapClickCoordinates={coordinatesToCreateIncident} /> */}
        </>
    )
};

export const PropertiesBox = ({ title, value }) => {
    return (
        <>
            <div style={{ color: '#63666A' }}>{title}</div>
            <div>{value}</div>
        </>
    )
};